import React from 'react'
import DashboardLayout from '../../../layout/dashboard'
import { Divider } from 'primereact/divider'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Checkbox } from 'primereact/checkbox'
import SignIcon from "../../../assets/icons/sign-document.svg"
import { useNavigate } from 'react-router-dom'
import CustomButton, { OutlineCustomButton } from "shared/components/inputButton";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import Sign from "../../../assets/icons/Sign.svg"

export default function PaperWorkClearence() {
    const navigate = useNavigate(); // Hook for programmatic navigation

    const handleContactReview = () => {
        navigate('/contract-review'); // Replace with your target route
    };
    const paperwork = [
        { document: "Publishing Clearance Form", status: "Ready To Sign", optional: false },
        { document: "Side Artist Agreement", status: "Start Drafting", optional: true },
        { document: "Producer Agreement", status: "Ready To Sign", optional: true },
        { document: "Mixing And Mastering Agreement", status: "Ready To Sign", optional: true },
        { document: "Artwork Agreement", status: "Ready To Sign", optional: true },
        { document: "Music Video Agreement", status: "Ready To Sign", optional: true },
    ];

    const renderCheckbox = (rowData) => (
        <Checkbox checked={!rowData.optional}></Checkbox>
    );

    const renderStatusButton = (rowData) => (
        <p
            className={`border-round-lg text-white text-center flex items-center justify-center ${rowData.status === "Start Drafting" ? "bg-yellow-500" : "sycamore-bg"
                }`}
            style={{
                fontSize: "14px",
                width: "123px",
                height: "38px",
                display: "flex",  // Ensure flex works in inline style
                alignItems: "center",
                justifyContent: "center"
            }}
        >
            {rowData.status}
        </p>
    );


    const renderUploadButton = () => (
        <Button label="Upload" className="p-button-sm p-button-secondary" style={{ background: "rgba(84, 89, 51, 1)", border: "none" }} />
    );

    const IconTemplate = () => (
        <img src={SignIcon} alt="" />
    );
    return (
        <DashboardLayout>
            <div className='mb-3'>
                <h2>Create New Project</h2>
            </div>
            <div className="flex gap-2 justify-content-end align-items-center">
                <Button label="Create New Project" extraClass="w-auto border-round-3xl" style={{ background: "rgba(84, 89, 51, 1)", borderRadius: "100px", border: "none" }} />
            </div>
            <div className="py-5">
                <h5 className='text-2xl mb-3 font-medium'>Congratulations! <span className='color-sycamore'>Forestry</span> has been created.</h5>
                <p className='color-verdigris text-2xl' style={{ color: "rgba(84, 89, 51, 1)" }}>Your Agreement List for Clearance</p>
                <Divider />
                <DataTable className='mb-3' value={paperwork} responsiveLayout="scroll">
                    <Column body={renderCheckbox} header="" style={{ width: "3rem" }} />
                    <Column field="document" header="Document" />
                    <Column body={renderStatusButton} header="Status" style={{ width: "123px" }} />
                    <Column body={renderUploadButton} header="" />
                </DataTable>
                <div className="flex gap-3 justify-content-between">
                    <Button label="Create New Project" extraClass="border-round-3xl" style={{ background: "transparent", color: "rgba(150, 161, 61, 1)", borderRadius: "100px" }} outlined />
                    <Button label="Sign" extraClass="w-auto border-round-3xl" onClick={handleContactReview} style={{ background: "rgba(150, 161, 61, 1)", borderRadius: "100px", border: "none", gap: "5px", fontWeight: "600px" }}
                        icon={<img src={Sign} alt="Sign" className="w-5 h-5" />} />
                </div>
            </div>
        </DashboardLayout>
    )
}
